import React, { Component } from "react";
import Slider from "react-slick";
import Card from "react-bootstrap/Card";
import styles from '../styles/contcatus.module.scss';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CustomImage from "./CustomImage";
interface Props {
  data: any;
}

const ManagersSlider: React.FC<Props> = ({ data }) => {
  const settings = {
    dotsClass: styles.sliderDots,
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  };
  return (
    <div id="managers-slidr" className={styles.regionaManagerSlider}>
      <Slider {...settings} className={styles.slider}>
        {
          data.map((card: any) => {
            return (
              <div className={styles.sliderCardDiv}>
                <Card className={styles.card}>
                  <Card.Body>
                    <div className={styles.regiManagerImg}>
                      <CustomImage src={card?.imageUrl} layout="responsive" height={250} width={250} className={styles.regiManagerImg} alt={""} />
                    </div>
                    <Card.Title className={styles.title}>{card?.name}</Card.Title>
                     <Card.Title className={styles.designation}>{card?.designation}</Card.Title>
                    <Card.Subtitle className={styles.subtitle}>{card?.location}</Card.Subtitle>
                    <Card.Text className={styles.text}>{card?.mobile}</Card.Text>
                    <Card.Text className={styles.text}>{card?.email}</Card.Text>
                  </Card.Body>
                </Card>
              </div>
            )
          })
        }
      </Slider>
    </div>
  );
}


export default ManagersSlider;
